import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, TextField, Checkbox, Chip, Backdrop, CircularProgress, Autocomplete, IconButton, Snackbar, Tooltip } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { tr } from 'date-fns/locale';
import format from 'date-fns/format';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';
import { isValid, parse } from 'date-fns';
import PropTypes from 'prop-types';
import Alert from 'src/components/Alert';



const ReferansTarihiDialog = ({ open, onClose, backdropSx }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [confirmOpen, setConfirmOpen] = useState(false);
  const SessionUser = getUser();
  const [selectedbolgeAdiKoduFormForConfirm, setSelectedbolgeAdiKoduFormForConfirm] = React.useState([]);
  const [SelectedBirimForConfirm, setSelectedBirimForConfirm] = React.useState([]);
  const [BirimDataForConfirm, setBirimDataForConfirm] = React.useState([]);
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [BirimData, setBirimData] = React.useState([]);
  const [berataUygunMu, setBerataUygunMu] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState('default');
  const [responseMessage, setResponseMessage] = useState('');

  const uyariGoster = (message, tip = 'error') => {
    setResponseMessage(message);
    setUyariTip(tip);
    setUyari(true);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  useEffect(() => {
    getBolgeAdiKoduData();
  }, []);

  useEffect(() => {
    if (SelectedBirimForConfirm.BirimKodu > 0) {
      getReferansTarihi();
    }
  }, [SelectedBirimForConfirm]);

  const handleConfirmClick = () => {
    if (selectedDate) {
      setConfirmOpen(true);
    }
  };

  const getReferansTarihi = () => {
    setLoading(true);
    axios
      .get(`GetYSReferansDate?BirimKodu=${SelectedBirimForConfirm.BirimKodu}`)
      .then((response) => {
        if (response.data.length > 0) {
          const parsedDate = parse(response.data, 'dd-MM-yyyy', new Date());
          const formattedDate = format(parsedDate, 'dd-MM-yyyy');
          if (formattedDate === '01-01-1900') {
            uyariGoster('Bu servis berat için uygun değil.', 'error');
            setBerataUygunMu(false);
          } else {
            setBerataUygunMu(true);
          }
          setSelectedDate(parsedDate);
        }
        setLoading(false);
      })
      .catch(() => {
        uyariGoster('Sunucuya bağlanırken bir hata oluştu.', 'error');
        setLoading(false);
      });
  };

  const handleActualConfirm = () => {
    setSubmitting(true);
    const formattedDateForSQL = format(selectedDate, 'yyyy-MM-dd');
    axios
      .post(`SetYSRefDate?RefTarihi=${formattedDateForSQL}&BirimKodu=${SelectedBirimForConfirm.BirimKodu}`)
      .then((response) => {
        if (response.data.ErrorCode === "0") {
          setSelectedDate(new Date());
          setConfirmOpen(false);
          setSelectedBirimForConfirm([]);
          setSelectedbolgeAdiKoduFormForConfirm([]);
          setBerataUygunMu(false);
          setSubmitting(false);
          onClose();
        } else {
          uyariGoster('İşlem sırasında bir hata oluştu.', 'error');
          setSubmitting(false);
        }
      })
      .catch(() => {
        uyariGoster('Sunucuya bağlanırken bir hata oluştu.', 'error');
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    setSelectedBirimForConfirm([]);
    setSelectedbolgeAdiKoduFormForConfirm([]);
    setSelectedDate(new Date());
    setConfirmOpen(false);
    setBerataUygunMu(false);
    onClose();
  };

  const getBirimDataForConfirm = (BirimKodu) => {
    if (!BirimKodu || BirimKodu.length < 1) {
      setBirimData([]);
    } else {
      setLoading(true);
      axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu.join("&BirimKodu=")}`).then((response) => {
        setBirimDataForConfirm([SelectAllOption, ...(Array.isArray(response.data) ? response.data : [])]);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  }

  const getBolgeAdiKoduData = () => {
    setLoading(true);
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(Array.isArray(response?.data) ? response.data : []);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }

  const renderOption = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>
  );

  const onaylaDisabledReason = !isValid(selectedDate)
    ? 'Geçerli bir tarih seçiniz.'
    : !(SessionUser.Role_Id === 1 || SessionUser.Role_Id === 3)
      ? 'Bu işlem için yetkiniz yok.'
      : !berataUygunMu
        ? 'Önce bir servis seçin; seçilen servis berat için uygun olmalı.'
        : '';

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <Snackbar
        open={uyari}
        autoHideDuration={6000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} variant={uyariTip} message={responseMessage} />
      </Snackbar>
      <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Referans Tarihi Girme
          <IconButton aria-label="close" size="small" onClick={handleCancel}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Backdrop sx={backdropSx} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Autocomplete
                multiple
                size="small"
                id="combo-box-demo"
                fullWidth
                value={selectedbolgeAdiKoduFormForConfirm}
                options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                renderOption={renderOption}
                onChange={(event, newValue) => {
                  setSelectedbolgeAdiKoduFormForConfirm(newValue);
                  var bolgeKodu = newValue?.find(x => x.BirimKodu == 0) ? bolgeAdiKodu.map(x => x.BirimKodu) : newValue.map(x => x.BirimKodu);
                  getBirimDataForConfirm(bolgeKodu);
                  setSelectedBirimForConfirm([]);
                }}
                renderTags={(tagValue, getTagProps) => {
                  if (bolgeAdiKodu.length > 0 && tagValue.length === bolgeAdiKodu.length) {
                    return <Chip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                  }
                  const visibleCount = 1;
                  return (
                    <>
                      {tagValue.slice(0, visibleCount).map((option, index) => (
                        <Chip size="small" key={option.BirimKodu} label={option.Dsc} {...getTagProps({ index })} />
                      ))}
                      {tagValue.length > visibleCount && (
                        <Chip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                      )}
                    </>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}
              />
            </Grid>
            <Grid size={12}>
              <Autocomplete
                limitTags={1}
                size="small"
                id="combo-box-demo"
                fullWidth
                value={SelectedBirimForConfirm}
                options={BirimDataForConfirm.length > 0 ? BirimDataForConfirm : []}
                getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                renderOption={renderOption}
                onChange={(event, newValue) => {
                  setSelectedBirimForConfirm(newValue || []);
                }}
                renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}
              />
            </Grid>
            <Grid size={12}>
              <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary' }}>
                Referans Tarihi
              </Typography>
              <DatePicker
                value={selectedDate}
                onChange={(newDate) => setSelectedDate(newDate)}
                format="dd.MM.yyyy"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: 'small',
                    variant: 'outlined'
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="error">
            İptal
          </Button>
          <Tooltip title={onaylaDisabledReason} disableHoverListener={!onaylaDisabledReason}>
            <span>
              <Button
                onClick={handleConfirmClick}
                variant="contained"
                disabled={!!onaylaDisabledReason}
                style={onaylaDisabledReason ? undefined : { backgroundColor: '#f57c00', color: '#fff' }}
              >
                Onayla
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>

      {/* Onay Dialogu */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Onayla</DialogTitle>
        <DialogContent>
          <Typography>
            {isValid(selectedDate) && (
              <strong>{format(selectedDate, 'dd.MM.yyyy')} tarihini seçtiniz. </strong>
            )}
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Bu tarih baz alınarak servisin referans tarihi güncellenecek. Emin misiniz?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="error" disabled={submitting}>
            İptal
          </Button>
          <Button
            onClick={handleActualConfirm}
            variant="contained"
            color="primary"
            disabled={submitting}
            startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
            style={{ backgroundColor: '#f57c00', color: '#fff' }}
          >
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default ReferansTarihiDialog;

ReferansTarihiDialog.propTypes = {
  backdropSx: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool
};
